// extracted by mini-css-extract-plugin
module.exports = {"root":"DrawerCloseIcon_root__3IGRY"};